import { messages } from '../../../../../../messages';
export var getModalContent = function getModalContent(product, resourceType) {
  var _modalContentMap$prod;
  var modalContentMap = {
    confluence: {
      page: {
        modalTitle: messages.automation_action_confluence_page_modal_title,
        modalDescription: messages.automation_action_confluence_page_modal_description
      }
    }
  };
  return modalContentMap === null || modalContentMap === void 0 || (_modalContentMap$prod = modalContentMap[product]) === null || _modalContentMap$prod === void 0 ? void 0 : _modalContentMap$prod[resourceType];
};